import { render, staticRenderFns } from "./LicenseAgreement.vue?vue&type=template&id=e4f60916&scoped=true"
import script from "./LicenseAgreement.vue?vue&type=script&lang=ts"
export * from "./LicenseAgreement.vue?vue&type=script&lang=ts"
import style0 from "./LicenseAgreement.vue?vue&type=style&index=0&id=e4f60916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f60916",
  null
  
)

export default component.exports